import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const benefits = [
  {
    icon: 'ri-heart-pulse-line',
    title: 'Ritmo cardíaco 24/7',
    description:
      'Monitoreo continuo con sensores ópticos de alta precisión. Detecta irregularidades antes de que las sientas.',
    color: 'bg-rose-50',
    iconColor: 'text-rose-600',
  },
  {
    icon: 'ri-moon-clear-line',
    title: 'Sueño inteligente',
    description:
      'Analiza tus fases de sueño con detalle. Despierta en el momento óptimo de tu ciclo para sentirte renovado.',
    color: 'bg-indigo-50',
    iconColor: 'text-indigo-600',
  },
  {
    icon: 'ri-run-line',
    title: 'Actividad diaria',
    description:
      'Pasos, calorías, distancia y niveles de esfuerzo. Todo registrado sin que tengas que pensar en ello.',
    color: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
  },
  {
    icon: 'ri-battery-2-charge-line',
    title: 'Batería de 7 días',
    description:
      'Olvídate de cargarlo a diario. Una semana completa de datos sin interrupciones ni cables molestos.',
    color: 'bg-amber-50',
    iconColor: 'text-amber-600',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Diseño premium resistente',
    description:
      'Titanio aeronáutico, resistente al agua (IP68) y cómodo 24 horas. Pesa menos que una moneda de 1€.',
    color: 'bg-stone-100',
    iconColor: 'text-stone-700',
  },
];

const BenefitsSection = () => {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation();
  const { ref: cardsRef, isVisible: cardsVisible } = useScrollAnimation({ threshold: 0.05 });

  return (
    <section id="beneficios" className="py-28 bg-white w-full">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div
          ref={titleRef}
          className={`text-center max-w-2xl mx-auto mb-20 scroll-hidden ${titleVisible ? 'scroll-visible' : ''}`}
        >
          <span className="font-body text-xs font-semibold tracking-widest text-amber-700 uppercase block mb-4">
            Por qué HELIX
          </span>
          <h2 className="font-display text-4xl lg:text-5xl font-light text-stone-900 leading-tight mb-5">
            Todo lo que necesitas.
            <br />
            <em className="not-italic font-semibold">Nada que no uses.</em>
          </h2>
          <p className="font-body text-stone-500 text-base leading-relaxed">
            Un solo anillo concentra lo que antes necesitaba cinco dispositivos.
            Diseñado para quien vive sin límites.
          </p>
        </div>

        {/* Cards grid */}
        <div
          ref={cardsRef}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {benefits.map((benefit, i) => (
            <div
              key={benefit.title}
              className={`group p-8 rounded-2xl border border-stone-100 hover:border-amber-200 transition-all duration-300 cursor-default scroll-hidden ${
                cardsVisible ? 'scroll-visible' : ''
              }`}
              style={{ transitionDelay: cardsVisible ? `${i * 0.1}s` : '0s' }}
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl ${benefit.color} mb-6 group-hover:scale-110 transition-transform duration-300`}
              >
                <i className={`${benefit.icon} text-2xl ${benefit.iconColor}`} />
              </div>
              <h3 className="font-display text-xl font-semibold text-stone-900 mb-3">
                {benefit.title}
              </h3>
              <p className="font-body text-stone-500 text-sm leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}

          {/* Highlight card */}
          <div
            className={`group p-8 rounded-2xl gold-gradient text-white col-span-1 sm:col-span-2 lg:col-span-0 scroll-hidden ${
              cardsVisible ? 'scroll-visible' : ''
            }`}
            style={{ transitionDelay: cardsVisible ? '0.5s' : '0s' }}
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/20 mb-6">
              <i className="ri-award-line text-2xl text-white" />
            </div>
            <h3 className="font-display text-xl font-semibold text-white mb-3">
              Precisión clínica
            </h3>
            <p className="font-body text-white/80 text-sm leading-relaxed">
              Algoritmos validados clínicamente con una precisión del 99.2% en
              mediciones de SpO2 y frecuencia cardíaca.
            </p>
          </div>
        </div>

        {/* Ring image centered */}
        <div className={`mt-24 text-center scroll-hidden ${titleVisible ? 'scroll-visible delay-200' : ''}`}>
          <div className="relative inline-block">
            <div className="absolute inset-0 bg-amber-100/50 rounded-full blur-3xl scale-75 opacity-60" />
            <img
              src="https://public.readdy.ai/ai/img_res/cdc7d077998d2fadf620073e0476bac6.jpg"
              alt="HELIX Smart Ring vista detalle"
              className="relative w-full max-w-lg mx-auto object-contain animate-float"
              style={{ height: '280px' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
